if (typeof TPS == 'undefined' || !TPS) {
    var TPS = {};
}


TPS.Util = {
    submitSpinner: '<span class="icon ion-ios-loop fa-spin"></span>',
    checkAnimated: function (selector) {
        return jQuery(selector).is(':animated');
    },
    checkActive: function (selector, activeClass) {
        return jQuery(selector).hasClass(activeClass);
    },
    getScreenWidth: function () {
        return jQuery(window).width();
    },
    exists: function (namespace) {
        var tokens = namespace.split('.');
        return tokens.reduce(function (prev, curr) {
            return (typeof prev == "undefined") ? prev : prev[curr];
        }, window);
    },
    loadWebserviceJS: function (namespace) {
        if (!TPS.Util.exists(namespace)) {
            var webserviceName = namespace.replace('CMSApp.', '').replace(/\./g, '/');
            jQuery.ajax({
                url: '/' + webserviceName + '.asmx/js',
                dataType: 'script',
                async: false
            });
        }
    },
    displayError: function (data) {
        console.log('TPS.Util.displayError:');
        console.log(data);
    },
    populateDropdown: function (sel, options, clearFirst, defaultVal) {
        var dd = jQuery(sel);

        if (clearFirst) {
            jQuery('option', dd).remove();
        }

        jQuery.each(options, function (i, v) {
            var selected = false;
            if (v.Value == defaultVal) {
                selected = true;
            }
            dd.append(jQuery("<option />").attr('value', v.Value).prop('selected', selected).text(v.Text));

        });


    },
    initCountryStateDropDown: function (ddCountrySel, ddStateSel, defaultCountry, defaultState) {
        TPS.Util.loadWebserviceJS('CMSApp.AV.API.Program');

        CMSApp.AV.API.Program.AvailableCountries(function (d) {

            jQuery(ddCountrySel).find('option').remove();
            jQuery.each(d, function (i, v) {
                jQuery(ddCountrySel).append(jQuery('<option />').attr('value', v.ID).text(v.Name));
            });
            jQuery(ddCountrySel).val(defaultCountry);

            jQuery(ddCountrySel).change(function () {

                CMSApp.AV.API.Program.AvailableStates(jQuery(ddCountrySel).val(), function (e) {
                    jQuery(ddStateSel).html('');
                    jQuery.each(e, function (i, v) {
                        jQuery(ddStateSel).append(jQuery('<option />').attr('value', v.Id).text(v.Name));
                        jQuery(ddStateSel).val(defaultState);
                    });
                }, TPS.Util.displayError);

            });

            jQuery(ddCountrySel).trigger('change');
        }, TPS.Util.displayError);
    },
    getStateLabel: function (c, s, sel) {
        CMSApp.AV.API.Program.AvailableStates(c, function (d) {
            var stateName;
            jQuery.each(d, function (i, v) {
                if (v.Id == s) {
                    stateName = v.Name;
                    return false;
                }
            });
            jQuery(sel).text(stateName);
        }, TPS.Util.displayError);
    },
    getCountryLabel: function (c, sel) {
        
        CMSApp.AV.API.Program.AvailableCountries(function (d) {
            var countryName;
            jQuery.each(d, function (i, v) {
                if (v.ID == c) {
                    countryName = v.Name;
                    return false;
                }
            });
            jQuery(sel).text(countryName);
        }, TPS.Util.displayError);
    },
    smoothScroll: function (selector) {

        var target = jQuery(selector);
        //console.log(elem);
        if (target.length > 0) {
            jQuery('html,body').animate({
                scrollTop: target.offset().top - 150
            }, 800, "swing");
            return false;
        }

    },
    // set cookie value
    setCookie: function (cname, cvalue, cexpiration) {
        if (!cexpiration) {
            cexpiration = 365;
        }
        var d = new Date();
        d.setTime(d.getTime() + (cexpiration * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    // get cookie value
    getCookie: function (cname) {
        if (cname) {
            var name = cname + '=';
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return false;
        } else {
            return false;
        }
    },
    getUrlParameter: function (parameterName, url) {
        if (!url) {
            url = location.href;
        }

        url = url.replace(/(.*)(\?.+)/i, '$2');

        var result = null, tmp = [];
        var items = url.substr(1).split('&');

        for (var index = 0; index < items.length; index++) {
            tmp = items[index].split('=');

            if (tmp[0] === parameterName) {
                result = decodeURIComponent(tmp[1]);
            }
        }

        return result;
    },
    validateEmail: function (email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },
    formatPrice: function (price) {
        var negative = parseFloat(price) >= 0 ? false : true;
        var price = negative ? -price : price; // Change to positive, since the - sign will be added before the $
        var dollar = negative ? '-$' : '$';
        var formattedPrice = dollar + price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        return formattedPrice;
    },
}

